import moment from 'moment';
import { get } from 'lodash';
import { specialFilterColors, overviewFilterColors } from '@utils/colorPalette';
import { initialFilter, initialWidgets, initialMetric } from './helper';
import { getDateShortcuts } from '@src/utils/tz';
import { parseFilters } from '@src/store/common/persistence';

export function filterPersistedData(persistedOvb) {
  const filter = get(persistedOvb, 'filter', initialFilter);
  const filterRule = [...filter.appliedFilters[0].rule];
  const parsedFilter = parseFilters(filterRule);
  filter.appliedFilters[0].rule = parsedFilter;
  const widgets = get(persistedOvb, 'widgets', initialWidgets);
  const selectedKPIMetric = get(persistedOvb, 'selectedKPIMetric', initialMetric);

  return {
    interval: getSelectedInterval(),
    filter,
    widgets,
    selectedKPIMetric,
    initializing: false, // load rest of the page
  };
}

export function filterShareddData(ovbStore) {
  return {
    ...ovbStore,
    initializing: false, // load rest of the page
  };
}

export function getColor(index, name) {
  // return if it's available in predefined colors
  const color = specialFilterColors.get(name);
  if (color) {
    return color;
  }

  const len = overviewFilterColors.length;
  return overviewFilterColors[index % len];
}

const getSelectedInterval = () => {
  const shortcuts = getDateShortcuts();
  const [shortcut, interval] = shortcuts[0];

  // set initial selected interval
  const selectedInterval = {
    from: moment(interval[0]).format(),
    to: moment(interval[1]).format(),
    shortcut,
  };

  return selectedInterval;
};
